import { getV1CompaniesCompanyIdCompanyDayJobStatsDate } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import connection from '~services/connectionModule';

import { CompanyDayJobStat } from './models';

type GetCompanyDayJobStatsByCompanyIdAndDateQueryProps = {
  companyId: string;
  date: string;
};

export default function useCompanyDayJobStat() {
  const getCompanyDayJobStatsByCompanyIdAndDate = useCallback(
    async ({ companyId, date }: GetCompanyDayJobStatsByCompanyIdAndDateQueryProps) => {
      try {
        const response = await getV1CompaniesCompanyIdCompanyDayJobStatsDate({
          path: { 'company-id': companyId, date },
        });

        return CompanyDayJobStat.parse(response.data.data);
      } catch (error) {
        console.error(error);
        connection.handleRequestError(
          error,
          t(
            'error_messages.company_day_job_stats.failed_to_fetch_company_day_job_stats',
          ) as string,
        );
      }
    },
    [],
  );

  return { getCompanyDayJobStatsByCompanyIdAndDate };
}
